"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _growth = require("./growth");

Object.keys(_growth).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _growth[key];
    }
  });
});

var _polynomial = require("./polynomial");

Object.defineProperty(exports, "solvePolynomial", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_polynomial).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6WyJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiOzs7Ozs7OztBQUNBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7Ozs7OzsrQ0FDUUEsTyIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbIi8vIEBmbG93XG5leHBvcnQgKiBmcm9tIFwiLi9ncm93dGhcIlxuZXhwb3J0IHtkZWZhdWx0IGFzIHNvbHZlUG9seW5vbWlhbH0gZnJvbSBcIi4vcG9seW5vbWlhbFwiXG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../growth/lib/index.js
// module id = 793
// module chunks = 0